import { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import i18n from '@/Config/app/i18n';
import { IndexPath } from '@/Config/app/router/index.path';
import { SupportLanguageEnum } from '@/Domain/enum/SupportLanguage.enum';

const SUPPORTED_LANGUAGES = [
  SupportLanguageEnum.en,
  SupportLanguageEnum.pl,
  SupportLanguageEnum.de,
  SupportLanguageEnum.fr,
  SupportLanguageEnum.es,
  SupportLanguageEnum.pt,
  SupportLanguageEnum.ja,
  SupportLanguageEnum.sv,
];

const supported_languages_labes = {
  [SupportLanguageEnum.en]: i18n.t('translation_language:en'),
  [SupportLanguageEnum.pl]: i18n.t('translation_language:pl'),
  [SupportLanguageEnum.de]: i18n.t('translation_language:de'),
  [SupportLanguageEnum.fr]: i18n.t('translation_language:fr'),
  [SupportLanguageEnum.es]: i18n.t('translation_language:es'),
  [SupportLanguageEnum.pt]: i18n.t('translation_language:pt'),
  [SupportLanguageEnum.ja]: i18n.t('translation_language:ja'),
  [SupportLanguageEnum.sv]: i18n.t('translation_language:sv'),
};

export const useSuggestLanguageSwitch = () => {
  const { t } = useTranslation('page_language_availability');
  const hasSuggested = useRef(false);

  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (hasSuggested.current) return;
    hasSuggested.current = true;

    if (typeof window === 'undefined') return;

    const browserLanguages = navigator.languages ?? [navigator.language];
    const preferredLanguages = browserLanguages.map((lang) => lang.split('-')[0]);
    const currentLang = i18n.language as SupportLanguageEnum;
    const matchedLang = preferredLanguages.find((lang) =>
      SUPPORTED_LANGUAGES.includes(lang as SupportLanguageEnum),
    );

    if (!matchedLang) return;
    if (currentLang === matchedLang) return;
    if (localStorage.getItem('__qc_preferred_language')) return;

    localStorage.setItem('__qc_preferred_language', matchedLang);
    toast.info(t('title'), {
      closeButton: true,
      duration: 10000,
      description: t('description', {
        language: supported_languages_labes[matchedLang as SupportLanguageEnum],
      }),
      action: {
        label: t('action_button'),
        onClick: () => {
          navigate(IndexPath.settings);
        },
      },
    });
  }, [location]);
};
